export default "__VITE_ASSET__CCF26kvh__"